<template>
  <v-sheet
    color="white"
    elevation="1"
    class="pa-5 notify"
  >

    <v-chip
      color="#3D9970"
      dark
      v-if="shouldNotify"
      class="state"
    >
      Enabled
    </v-chip>
    <v-chip
      v-if="!shouldNotify"
      class="state"
      color="#FF4136"
      dark
    >
      Disabled
    </v-chip>
    <h3>Notifications</h3>

    <p>We will notify you by e-mail of new files available on your connected accounts. You can disable these notifications by adjusting your settings here.</p>

    <div>
      <v-switch
        v-model="enabled"
        :disabled="isProcessing"
        @change="updateState"
        color="secondary"
        label="Notify new files"
      ></v-switch>
      <v-progress-circular
        v-if="isProcessing"
        color="primary"
        class="loading-spinner"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-sheet>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  name: "ManageNotifications",
  computed: {
    shouldNotify: get('auth/user.shouldNotify'),
  },
  data: () => ({
    enabled: false,
    isProcessing: false
  }),
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.enabled = this.shouldNotify;
    },
    async updateState(newState) {
      this.isProcessing = true;

      const response = await this.$store.dispatch("auth/updateShouldNotify", {
        should_notify: newState,
      });

      if (!response) {
        this.enabled = !newState;
      }

      this.isProcessing = false;
    },
    regenerateCodes() {
      this.$swal({
        title: "Regenerate Recovery Codes",
        icon: "warning",
        input: "html",
        html:
          '<div id="swal-content1">NOTE: This will invalidate your existing codes and generate new codes</div>' +
          '<input id="swal-input1" class="swal2-input" type="password" placeholder="Your Password" style="text-align: center">' +
          '<div id="swal-error"></div>',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Regenerate",
        showLoaderOnConfirm: true,
        customClass: {
          input: "d-none"
        },
        preConfirm: async () => {
          const pass = document.getElementById("swal-input1").value;

          const result = await this.$store.dispatch("auth/recoveryCodeReset", {
            pass: pass,
          });

          if (result.success) {
            this.newCodes = result.codes;
            await this.$store.dispatch("notification/triggerSuccess", { title: "Recovery Codes Reset", detail: "Please download / copy them to a secure place" });
          }

          return true;
        },
        inputValidator: () => {
          if (!document.getElementById("swal-input1").value) {
            return "Please confirm your password";
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 0.9rem;
  color: #777;
  margin-top: 10px;
}

.notify {
  position: relative;
  margin-top: 20px;

  .state {
    position: absolute;
    right:20px;
    top:20px;
  }

}

.loading-spinner {
  position: absolute;
  right: 20px;
  bottom: 20px;
}

h4 {
  margin-top: 20px;
}

</style>
